<template>
    <div class="header-wrapper">
        <div class="main flex-bt">
            <div class="left flex-start">
                <a href="#" @click="goto({ path: '/' })" class="logo">
                    <img src="@/assets/images/logo.png" alt="">
                </a>
                <div class="menu flex-start">
                    <a class="items flex-start" @click="goto({ path: '/' })">首頁</a>
                    <a @click="goto(item)" class="items flex-start" v-for="(item, index) in menu" :key="index">
                        {{ item.name }}
                        <img  v-if="item.children" class="icon" src="@/assets/images/menu-bottom.png" alt="">
                        <div class="children" v-if="item.children">
                            <div class="child-item flex-start" @click.stop="goto(child)"
                                v-for="(child, childIndex) in item.children" :key="childIndex">{{ child.name }}  
                            </div>
                        </div>
                    </a>
                </div>
            </div>
            <div class="right flex-end">
                <router-link to="/register">
                    <a href="#" class="button active">立即註冊</a>
                </router-link>

                <a target="_blank" href="https://merchants.loopshop.com.hk/" class="button">商戶登入</a>


                <img class="mobile-menu" @click="checkMenu" src="@/assets/images/mobile-menu.png" alt="">
            </div>
            <div class="mobile-menu-box" :class="menuOpen ? '' : 'active'">
                <div class="main">
					<a class="items flex-start" @click="goto({ path: '/' })">首頁</a>
                    <a class="items flex-bt" v-for="(item, index) in menu" :key="index">
                        <span @click="goto(item, 'mobile')"> {{ item.name }}</span>
                        <img class="icon" src="@/assets/images/menu-bottom.png" v-if="item.children"
                            :class="[item.open ? 'active' : '']" @click="item.open = !item.open" alt="">
                        <div class="children" v-if="item.children && item.open">
                            <div class="child-item flex-ce" @click.stop="goto(child)"
                                v-for="(child, childIndex) in item.children" :key="childIndex">{{ child.name }}
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            menuOpen: false,
            menu: [

                { name: '關於我們', path: '/about-us' },
                { name: '客戶案例', path: '/case-studies' },
                { name: '方案收費', path: '/plan' },
                { name: '開店講座', path: '/seminar' },
                { name: '開店諮詢', path: '/consultation' },
                {
                    name: '開店資源',
                    path: '/blog',
                    open: false,
                    children: [
                        { name: '電商教室', path: '/blog/' },
                        { name: '新手教學', path: '/start' },
                        { name: '常見問題', path: '/faq' },
                    ]
                },
            ]
        }
    },

    methods: {
        goto(val) {
            console.log('val:', val.path);
            if (val.path == '/blog') { return; }
            this.menuOpen = false
            this.$router.push(val.path)
        },

        checkMenu() {
            this.menuOpen = !this.menuOpen
        },
    }
}
</script>
<style lang="scss" scoped>
.header-wrapper {
    position: fixed;
    top: 0;
    width: 100%;
    height: 0.8rem;
    background: #ffffff;
    z-index: 99;

    .main {
        height: 100%;
    }

    .mobile-menu-box {
        // display: none;
        position: absolute;
        top: 1.6rem;
        left: 0;
        border-top: 1px solid #808080;
        width: 100%;
        height: 100vh;
        background: #ffffff;
        transition: all .6s;
        overflow: hidden;

        &.active {
            border-top: 0;
            height: 0vh;
        }

        .items {
            font-family: 'PingFang HK';
            font-style: normal;
            font-weight: 500;
            font-size: 0.32rem;
            line-height: 1rem;
            cursor: pointer;
            color: #808080;
            position: relative;
            width: 100%;
            height: 1rem;
            flex-wrap: wrap;

            span {
                flex: 1;
                font-weight: 500;
                font-size: 0.32rem;
                line-height: 1rem;
                cursor: pointer;
                color: #808080;
                position: relative;
                width: 100%;
                height: 1rem;
                flex-wrap: wrap;
            }

            .children {
                width: 100%;
            }

            .child-item {
                justify-content: space-between;
                padding-left: 0.2rem;
                font-size: 0.28rem;
                line-height: 0.8rem;
            }

            .icon {
                width: 0.36rem;
                height: 0.2rem;
                margin-left: 0.08rem;
                transition: all .6s;
                transform: rotate(-90deg);

                &.active {
                    transform: rotate(0deg);
                }
            }

        }
    }

    .left {
        height: 100%;

        .logo {
            width: 1.04rem;
            height: 0.48rem;
            margin-right: 0.48rem;

            img {
                width: 100%;
                height: 100%;
                display: block;
            }
        }



        .menu {
            height: 100%;

            .items {
                font-family: 'PingFang HK';
                font-style: normal;
                font-weight: 500;
                font-size: 0.16rem;
                line-height: 0.8rem;
                height: 100%;
                cursor: pointer;
                color: #808080;
                padding-right: 0.4rem;
                position: relative;

                &:hover {
                    color: #E02E43;

                    svg g {
                        stroke: #E02E43;
                    }

                    .children {
                        display: block;
                    }
                }

                .children {
                    position: absolute;
                    top: 0.8rem;
                    padding: 0.24rem;
                    background: #ffffff;
                    width: 100%;
                    width: 1.76rem;
                    left: -0.32rem;
                    box-shadow: 0 0.15rem 0.3rem rgba(0, 0, 0, .1);
                    display: none;

                    .child-item {
                        width: 100%;
                        height: 0.48rem;
                        font-size: 0.16rem;
                        color: #808080;

                        &:hover {
                            color: #E02E43;
                        }
                    }
                }

                .icon {
                    width: 0.18rem;
                    height: 0.1rem;
                    margin-left: 0.08rem;
                }
            }
        }
    }

    .right {
        .button {
            display: block;
            border: 1px solid #E02E43;
            color: #E02E43;
            font-size: 0.16rem;
            text-align: center;
            border-radius: 0.08rem;
            line-height: 0.16rem;
            margin-left: 0.24rem;
            padding: 0.16rem 0.18rem;

            &.active {
                background: #E02E43;
                color: #ffffff;
            }
        }

        .mobile-menu {
            width: 0.38rem;
            height: 0.38rem;
            margin-left: 0.24rem;
            display: none;
            cursor: pointer;
        }
    }
}

@media (min-width: 1200px) and (max-width: 1380px) {
    .header-wrapper .left .menu .items {
        padding-right: 0.24rem;
    }
}

@media (min-width: 750px) and (max-width: 1200px) {
    .header-wrapper .right .mobile-menu {
        display: block;
    }





    .header-wrapper .left .menu {
        display: none;
    }

    .header-wrapper {
        height: 1.6rem;
    }

    .header-wrapper .main {
        // width: 100%;
        // padding: 0 0.4rem;
    }

    .header-wrapper .right .mobile-menu {
        display: block;
        width: 0.5rem;
        height: 0.5rem;
    }
}

@media (max-width: 750px) {
    .header-wrapper .right .mobile-menu {
        display: block;
        width: 0.5rem;
        height: 0.5rem;
    }

    .header-wrapper .right .button {
        font-size: 0.26rem;
        line-height: 0.26rem;
        padding: 0.18rem 0.22rem;
    }

    .header-wrapper {
        height: 1.6rem;
    }



    .header-wrapper .left .menu {
        display: none;
    }

    .header-wrapper .main {
        // width: 100%;
        // padding: 0 0.4rem;
    }

    .header-wrapper .left .logo {
        width: 1.8rem;
        height: 0.8rem;
    }
}
</style>